import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getConfig } from '@zimpel/common/config';

const StyledList = styled.ul`
  list-style: none;
`;

const StyledListItem = styled.li`
  display: inline-block;
  font-size: var(--font-size-large);
  margin-right: 5px;

  &:last-child {
    margin-right: 0;
  }
`;

const StyledLink = styled.a`
  color: var(--color-text-bright);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledSpan = styled.span`
  text-decoration: underline;
`;

const LanguageSwitcher = () => {
  const location = useLocation();

  const {
    theme, i18NLocale,
  } = getConfig();

  const enParam = `en-US-${theme}`;
  const deParam = `de-DE-${theme}`;

  return (
    <StyledList>
      <StyledListItem>
        {
          i18NLocale === enParam ? <StyledSpan>EN</StyledSpan> : <StyledLink href={`${location.pathname}?locale=${enParam}`}>EN</StyledLink>
        }
      </StyledListItem>
      <StyledListItem>
        {
          i18NLocale === deParam ? <StyledSpan>DE</StyledSpan> : <StyledLink href={`${location.pathname}?locale=${deParam}`}>DE</StyledLink>
        }
      </StyledListItem>
    </StyledList>
  );
};

export default LanguageSwitcher;
